import { UserDetailsPartial } from 'src/auth/types';
import { supabaseClient } from 'src/auth/supabase';

import { studentBookingClient } from '../client';
import { StudentBookingSuccessResponse } from '../types';

import {
    GetValidTaxIdProcessSuccessResponse,
    GetUserHasBookingsSuccessResponse,
    GetUserInfoSuccessResponse,
    GetUserMetaDataSuccessResponse,
    GetValidateReferrerCodeSuccessResponse,
} from './types';
import { UserServiceApiEndpoints } from './constants';
import { SetUserPasswordUsingPinDto } from './dto/SetUserPasswordUsingPin.dto';

export const SetUserPasswordUsingPin = async (details: SetUserPasswordUsingPinDto) => {
    const { data: response } = await studentBookingClient.post<
        StudentBookingSuccessResponse<boolean>
    >(UserServiceApiEndpoints.SET_PASSWORD_USING_PIN, details);

    return response.data;
};

export const validateTaxId = async (taxId: string) => {
    const { data: response } = await studentBookingClient.get<GetValidTaxIdProcessSuccessResponse>(
        UserServiceApiEndpoints.VALIDATE_TAX_ID.replace('{taxId}', taxId)
    );

    return response.data;
};

export const userHasBookings = async () => {
    const { data: response } = await studentBookingClient.get<GetUserHasBookingsSuccessResponse>(
        UserServiceApiEndpoints.USER_HAS_BOOKINGS
    );

    return response.data;
};

export const getUserInfo = async () => {
    const { data: response } = await studentBookingClient.get<GetUserInfoSuccessResponse>(
        UserServiceApiEndpoints.USER_INFO
    );

    return response.data;
};

export const getUserMetaData = async () => {
    const { data: response } = await studentBookingClient.get<GetUserMetaDataSuccessResponse>(
        UserServiceApiEndpoints.USER_META_DATA
    );

    return response.data;
};

export const patchUserMetaData = async (metadata: UserDetailsPartial) => {
    const {
        data: { user },
        error,
    } = await supabaseClient.auth.updateUser({ data: metadata });

    if (error) throw error;

    return user;
};

export const getValidateReferralCode = async (referralCode: string) => {
    const { data: response } =
        await studentBookingClient.get<GetValidateReferrerCodeSuccessResponse>(
            UserServiceApiEndpoints.USER_VALIDATE_REFERRAL_CODE.replace(
                '{referralCode}',
                referralCode
            )
        );

    return response.data;
};
